/**
 * @param isValue true return values, false return keys
 */
const mapValuesOrKeysFromObject = (obj: { [x: string]: any }, isValues: boolean): string[] => {
	const arr: string[] = new Array()
	Object.keys(obj).map((key: any) => {
        if (isValues) {
            const value = obj[key]
            arr.push(value)
        } else {
            arr.push(key)
        }
	})
	return arr
}

export default mapValuesOrKeysFromObject
